module.exports = __webpack_public_path__ + "img/brighton.b2849e4d.png";